import { IonChip, IonLabel } from '@ionic/react';
import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { HelperBeeViewModel, IHelperBeeTrackingFrom } from './HelperBeeViewModel';
import { useSubscription } from '@meraki-internal/state';

const useStyles = createUseStyles({
    chip: {
        height: 40,
        color: '#fff',
        paddingLeft: 6,
        borderRadius: 24,
        overflow: 'visible',
        textAlign: 'center',
        border: '2px solid #4CAF50',
        '--background': 'linear-gradient(rgba(76, 175, 80, 1), rgba(27, 94, 32, 1))',

        '& > img': {
            width: '13%'
        },

        '& ion-label': {
            flexGrow: 1,
            fontWeight: 500
        }
    }
});

export type INativeBeeChatButtonProps = {
    'data-id'?: string;
    trackingFrom: IHelperBeeTrackingFrom;
};

export const NativeBeeChatButton: FC<INativeBeeChatButtonProps> = ({
    trackingFrom,
    'data-id': dataId
}) => {
    const classes = useStyles();

    const chatModalVM = useInstance(HelperBeeViewModel);
    useSubscription(() => chatModalVM);

    const onClickChip = () => {
        chatModalVM.open({ trackingFrom, label: 'Bubble Chat (Dev)' });
    };

    return (
        <div data-id={dataId} style={{maxWidth: 260}}>
            <IonChip
                onClick={onClickChip}
                className={classes.chip}
            >
                <img alt="Bea" src="/assets/images/help/helper-bea.png" />
                <IonLabel style={{marginTop: -2}}>Bubble Chat (Dev)</IonLabel>
            </IonChip>
        </div>
    );
};
